import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  Typography,
  Box,
} from "@mui/material";
import React from "react";
import CommonStyle from "../../Common/style/Style";
import { StyledTableRow } from "../TableComponent/Table";
import useConfig from "../../hooks/useConfig";

const LastGamesTable = (props: any) => {
  const configData = useConfig();
  return (
    <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: 0 }}>
      <TableContainer sx={{ maxHeight: "auto" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {props.headers?.map((headItem: any) => (
                <TableCell
                  key={headItem.id}
                  align={headItem?.align ? headItem.align : "center"}
                  sx={{...CommonStyle.tableHeader,background:configData.primary}}
                  className="statview-header-color"                  colSpan={2}
                >
                  <Typography variant="body2" sx={{fontStyle:"normal",color:"#ffffff"}}>{headItem.label}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.listData.length ?(props.listData?.map((row: any, index: number) => {
              return (
                <StyledTableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={index + 1}
                  className="wtd-statview-table-row-color"
                >
                  <TableCell
                    sx={{ py: 1 }}
                    align={props?.align ? props.align : "left"}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: 5,
                        justifyContent: "flex-start",
                      }}
                    >
                      <Typography variant="body2" sx={{ width: "40px",fontSize:"12px" }}>
                        {row.away_goals}-{row?.home_goals}
                      </Typography>{" "}
                      <Typography variant="body2" sx={{fontSize:"12px"}}>{row?.result}</Typography>
                      <Typography variant="body2" sx={{fontSize:"12px"}}>
                        {row.opp_seperator} {row.opp_name}
                      </Typography>
                    </Box>
                  </TableCell>
                </StyledTableRow>
              );
            })):(
              <Typography variant="body2">
                No Available
              </Typography>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default LastGamesTable;
